'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

//* HOC's
import { withLanguageContext } from '@/context';

//* Components
import Page from '@/components/common/Page';
import Text from '@/components/common/Text';

//* Style
import Custom404Style from '@/styles/pages/Custom404Style';

const NotFound = ({ selectedLang }) => {
	//! Next Navigation
	const router = useRouter();
	const pathname = usePathname();

	useEffect(() => {
		if (pathname !== '/not-found/') {
			router.push(`/${selectedLang}/not-found/`);
		}
	}, [router, pathname, selectedLang]);

	return (
		<Page className={`not-found`}>
			<Custom404Style>
				<div className={'error-container'}>
					<Text
						className={`black1000 h2 font-montserrat-medium m-bottom`}
						text={'error404'}
					/>

					<Text
						className={`black1000 h5 font-montserrat`}
						text={'error404_text1'}
					/>
				</div>
			</Custom404Style>
		</Page>
	);
};
export default withLanguageContext(NotFound, ['selectedLang']);
